module.exports = __webpack_public_path__ + "static/media/eocene_image_weight_scaletransparent.42a93708.png";